import Repository from './Repository'

const resource = 'line'

export default {
  async getListMessages (param, isSilent = false) {
    try {
      return await Repository.get(`${resource}/list-messages`, param, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async postMessageImage (data, isSilent = false) {
    try {
      return Repository.post(`${resource}/message`, data, { headers: { 'content-type': 'multipart/form-data' } }, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async postMessageText (data, isSilent = false) {
    try {
      return Repository.post(`${resource}/message`, data, { headers: { 'content-type': 'multipart/form-data' } }, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  async updateTextReply(reply_text_default, company_id, isSilent = false) {
    try {
      return Repository.post(`${resource}/bot`, { reply_text_default, company_id }, {}, {}, isSilent)
    } catch (e) {
      return this.setErrors(e)
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  }
}
